import { FC } from "react";
import { formatNIP } from "components/CreateRegistryEntryModal/formatters";
import CopyableValue from "../CopyableValue";

/**
 * NIP w drugim wierszu komórki Sprzedawca/Nabywca: prezentacja z maską
 * (formatNIP) + ikona „Kopiuj" na hover. Kopiowane są same cyfry NIP.
 */
const NipWithCopy: FC<{ nip?: string }> = ({ nip }) => {
  const raw = (nip ?? "").trim();
  if (!raw) return null;

  return (
    <CopyableValue
      display={formatNIP(raw)}
      copyValue={raw.replace(/\D/g, "") || raw}
      label="Kopiuj NIP"
    />
  );
};

export default NipWithCopy;
